/**
 * Substitui divs `overflow-y-auto` + painelPermissionsModalScrollClass
 * pela scrollbar foguete nos modais do painel.
 */
import type { HTMLAttributes, ReactNode } from 'react';
import { RocketScrollArea } from '@/components/help-center/CustomScrollbar';
import { cn } from '@/lib/utils';

type PainelRocketScrollProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  /** Classes do viewport (padding, etc.). */
  viewportClassName?: string;
};

export function PainelRocketScroll({
  className,
  viewportClassName,
  children,
  ...props
}: PainelRocketScrollProps) {
  return (
    <RocketScrollArea
      className={className}
      viewportClassName={cn('scroll-smooth', viewportClassName)}
      {...props}
    >
      {children}
    </RocketScrollArea>
  );
}
